import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { WeatherApi } from '../../../../core/api/weather.api';
import { DailyForecast } from '../../../../core/entities/weather/daily-forecast.model';

@Component({
  selector: 'app-weather-daily-forecast',
  templateUrl: './daily-forecast.component.html',
  styleUrl: './daily-forecast.component.scss',
})
export class DailyForecastComponent {
  dataSource = new MatTableDataSource<DailyForecast>();
  displayedColumns: string[] = ['date', 'twentyFourHourWeatherType', 'temperature', 'precipitation', 'wind'];
  loading = true;

  constructor(private weatherApi: WeatherApi) {
    this.weatherApi.getDailyForecast().subscribe(dailyForecast => {
      this.dataSource.data = dailyForecast;
      this.loading = false;
    });
  }
}
